import React, { useState } from 'react';
import { find } from 'lodash';
import classNames from 'classnames';

import styles from './trendingResearchStyles';

import ActivityFeedJoyride from 'buyside/components/presentation/Joyride/ActivityFeedJoyride/activityFeedJoyride';
import LoadingSpinner from 'buyside/components/presentation/LoadingSpinner/loadingSpinner';
import TrendingResearchHeader from 'buyside/components/presentation/TrendingResearch/TrendingResearchHeader/trendingResearchHeader';
import TrendingResearchList from 'buyside/components/presentation/TrendingResearch/TrendingResearchList/trendingResearchList';
import { ActivityFeedJoyrideTarget } from 'buyside/components/presentation/Joyride/ActivityFeedJoyride/activityFeedJoyrideHelper';

import ArrowsUpDownIcon from 'buyside/svgs/arrows_up_down.svg';
import MessageBubbleDoubleDarkIcon from 'buyside/svgs/message_bubble_double_dark.svg';
import TrendingIcon from 'buyside/svgs/trending.svg';

const trendingLabels = [
  { name: 'Actively Discussed', icon: MessageBubbleDoubleDarkIcon },
  { name: 'Trending Research', icon: TrendingIcon },
  { name: 'Biggest Movers', icon: ArrowsUpDownIcon }
];

function getInitialSelectedItem() {
  // Remove Biggest Movers as an initial display option
  // https://github.com/sumzero/sumzero/issues/5695
  const possibilities = trendingLabels.filter(item => item.name !== 'Biggest Movers');
  const idx = Math.floor(Math.random() * possibilities.length);
  return possibilities[idx];
}

const TrendingResearch = ({
  activeConversationIdeas,
  biggestMoverIdeas,
  loading,
  showUserDetails,
  trendingIdeas
}) => {
  const [selected, setSelected] = useState(getInitialSelectedItem());

  const changeSelection = name => {
    return () => {
      setSelected(find(trendingLabels, label => label.name === name));
    };
  };

  if (loading) {
    return (
      <div className={classNames(styles.trendingPanel, styles.loading)}>
        <LoadingSpinner type="secondary" />
      </div>
    );
  }
  let trendingItems;
  const selectedName = selected.name;
  if (selectedName === 'Actively Discussed') {
    trendingItems = activeConversationIdeas;
  } else if (selectedName === 'Trending Research') {
    trendingItems = trendingIdeas;
  } else if (selectedName === 'Biggest Movers') {
    trendingItems = biggestMoverIdeas;
  }

  return (
    <div
      className={styles.trendingPanel}
      data-joyride-target={ActivityFeedJoyrideTarget.TRENDING_RESEARCH}
      data-testid="trending-research"
    >
      <TrendingResearchHeader
        selectedName={selectedName}
        selectionList={trendingLabels}
        handleChange={changeSelection}
      />
      <TrendingResearchList trendingItems={trendingItems} showUserDetails={showUserDetails} />
      <ActivityFeedJoyride />
    </div>
  );
};

export default TrendingResearch;
